// Gestores (7-oct-2026). «Propietario y liquidación» (components/Gestores/OwnerSettlementPanel.vue
// y su modal OwnerFormModal.vue): la tarjeta del anuncio donde el gestor dice para quién lo lleva,
// quién cobra y cómo se le liquida.
export const ownerSettlement = {
  head: {
    title: "Propietario y liquidación",
    sub: "Si gestionas este alojamiento para otro dueño, define quién cobra, tu comisión y cómo se le liquida. Con esto se calculan sus liquidaciones y tu analítica de gestor.",
  },
  loading: "Cargando la configuración…",
  loadError: {
    title: "No se ha podido cargar la configuración",
    text: "Comprueba la conexión e inténtalo de nuevo.",
    retry: "Reintentar",
  },
  master: {
    label: "Gestiono este alojamiento para un propietario",
    hintOff: "El alojamiento es tuyo: sus reservas cuentan como ingresos propios.",
    hintOn: "Sus reservas se liquidan al propietario con las condiciones de abajo.",
    kept: "Lo que tenías configurado se conserva por si vuelves a activarlo.",
    introTitle: "Al activarlo:",
    intro1: "Eliges al propietario y quién cobra las reservas.",
    intro2: "Pones tu comisión, su IVA y quién se queda la limpieza.",
    intro3: "Ves al momento cómo queda su liquidación.",
  },
  owner: {
    title: "Propietario",
    hint: "La persona o empresa a la que le liquidas este alojamiento.",
    placeholder: "Elige un propietario",
    new: "Nuevo propietario",
    add: "Añadir propietario",
    edit: "Editar",
    emptyTitle: "Aún no tienes propietarios",
    emptyText: "Añade al dueño de este alojamiento para poder liquidarle.",
    missing: "Sin propietario asignado, la liquidación de este alojamiento no tendrá destinatario.",
    pending: "Se asigna al guardar",
    taxId: "NIF",
    addTaxId: "Añadir NIF",
    iban: "IBAN",
    addIban: "Añadir IBAN",
  },
  ownerForm: {
    titleNew: "Nuevo propietario",
    titleEdit: "Editar propietario",
    sub: "Sus datos salen en las liquidaciones de los alojamientos que le lleves.",
    close: "Cerrar",
    name: "Nombre o razón social",
    taxId: "NIF / CIF / NIE",
    taxIdHint: "Si es de otro país, su número de identificación fiscal.",
    taxIdDoubt: "Si es un NIF español, el carácter de control no cuadra. Si es de otro país, no hagas caso.",
    email: "Email",
    phone: "Teléfono",
    iban: "IBAN",
    ibanPlaceholder: "ES00 0000 0000 0000 0000 0000",
    ibanHint: "La cuenta a la que le transfieres su parte.",
    ibanOk: "IBAN válido · {country}",
    address: "Dirección",
    notes: "Notas",
    notesPlaceholder: "Lo que acordasteis, el día de pago…",
    sharedNote: "También es el propietario de {n} alojamiento más: los cambios se verán allí. | También es el propietario de {n} alojamientos más: los cambios se verán en todos.",
    cancel: "Cancelar",
    save: "Guardar propietario",
    saving: "Guardando…",
    created: "Propietario creado",
    updated: "Propietario actualizado",
    deleted: "Propietario eliminado",
    errName: "Escribe el nombre o la razón social.",
    errEmail: "Revisa el email: no parece válido.",
    errIbanFormat: "Un IBAN empieza por el código del país y dos dígitos de control (ES91…).",
    errIbanCheck: "Los dígitos de control no cuadran: revisa que esté bien copiado.",
    errIbanLength: "Un IBAN de {country} tiene {expected} caracteres y este tiene {actual}.",
    errSave: "No se ha podido guardar el propietario. Inténtalo de nuevo.",
    errDelete: "No se ha podido eliminar el propietario. Inténtalo de nuevo.",
    delete: "Eliminar propietario",
    deleteTitle: "¿Eliminar a {name}?",
    deleteText: "Desaparece de tu lista de propietarios. No se puede deshacer.",
    deleteConfirm: "Eliminar",
    deleteBlocked: "No se puede eliminar: es el propietario de {n} alojamiento. Quítaselo antes. | No se puede eliminar: es el propietario de {n} alojamientos. Quítaselo antes en cada uno.",
    discardTitle: "¿Descartar los cambios?",
    discardText: "Lo que has escrito de este propietario se perderá.",
    discardConfirm: "Descartar",
    discardCancel: "Seguir editando",
  },
  units: {
    title: "Propietario de cada unidad",
    hint: "Si alguna unidad es de otro dueño, elígelo aquí. Las demás se liquidan al propietario del anuncio.",
    inherit: "El del anuncio",
    summaryNone: "Todas son del propietario del anuncio",
    summarySome: "{n} unidad con otro propietario | {n} unidades con otro propietario",
  },
  collection: {
    title: "¿Quién cobra las reservas?",
    hint: "Cambia hacia dónde va el dinero, no lo que le queda al propietario.",
    ownerLabel: "Cobra el propietario",
    ownerDesc: "Las plataformas y tu web le pagan a él. Después te paga tu factura de honorarios (y la limpieza, si es tuya).",
    managerLabel: "Cobra el gestor",
    managerDesc: "El dinero de las reservas te llega a ti. Te quedas lo tuyo y le transfieres su parte.",
    flowBooking: "Reserva",
    flowOwner: "Propietario",
    flowYou: "Tú",
  },
  commission: {
    title: "Tu comisión",
    percent: "Porcentaje de comisión",
    vat: "IVA de tu comisión",
    base: "Se calcula sobre",
    presetTotal: "Total de la reserva",
    presetAccommodation: "Alojamiento sin limpieza",
    presetNet: "Neto después de comisión OTA",
    presetDescNet: "{concepts}, sin su parte de la comisión de la OTA",
    presetNetClean: "Neto después de OTA y limpieza",
    presetDescNetClean: "Lo que le queda al propietario antes de tus honorarios: el total menos la OTA, su IVA y la limpieza",
    exampleBase: "base en el ejemplo",
    custom: "Personalizado",
    customize: "Ajustar a mano",
    baseLabel: "Sobre qué importe",
    gross: "Lo que paga el huésped",
    net: "Lo que queda tras la comisión de la OTA",
    netClean: "Lo que queda tras la OTA y la limpieza",
    concepts: "Qué conceptos entran",
    warnTaxes: "Las tasas no son ingresos: normalmente no se cobra comisión sobre ellas.",
    fixTaxes: "Quitar las tasas",
    warnCleaning: "Estás cobrando comisión sobre una limpieza que ya te quedas.",
    fixCleaning: "Quitar la limpieza",
    warnDeposit: "La fianza se le devuelve al huésped: normalmente no se cobra comisión sobre ella.",
    fixDeposit: "Quitar la fianza",
    errPercent: "Pon un porcentaje entre 0 y 100.",
    errConcepts: "Elige al menos un concepto.",
  },
  concepts: {
    accommodation: "Alojamiento",
    cleaning: "Limpieza",
    taxes: "Tasas",
    extras: "Extras",
    deposit: "Fianza",
  },
  // Los mismos conceptos dentro de una frase («Base: alojamiento y extras.»)
  conceptsInline: {
    accommodation: "alojamiento",
    cleaning: "limpieza",
    taxes: "tasas",
    extras: "extras",
    deposit: "fianza",
  },
  cleaning: {
    title: "Limpieza",
    hint: "¿Quién se queda lo que paga el huésped por la limpieza?",
    owner: "Es del propietario",
    ownerDesc: "Va en su neto: no se le descuenta.",
    manager: "Es tuya",
    managerDesc: "La gestionas tú y se le descuenta al propietario.",
    charged: "Lo que paga el huésped por la limpieza",
    fixed: "Un importe fijo por estancia",
    fixedAmount: "Importe por estancia",
    fixedHint: "Si una reserva lleva varias habitaciones, se cuenta una vez por cada una.",
    errAmount: "Indica el importe fijo de la limpieza por estancia.",
  },
  ota: {
    title: "Comisión de cada OTA",
    moved: "Los % de cada OTA se configuran en la tarjeta «{card}».",
    open: "Abrir «{card}»",
  },
  example: {
    title: "Liquidación de ejemplo",
    sub: "Una reserva de {channel} de {total}, con tus condiciones actuales.",
    guest: "Lo que paga el huésped",
    platform: "Lo que se queda {channel}",
    platformNote: "Su comisión: {pct}\u00a0% de {base} ({concepts}).",
    platformYours: "Mandan tus % de «{card}», aunque {channel} mande su comisión.",
    platformReal: "Si {channel} manda su comisión de una reserva, se usa esa.",
    platformRule: "Si pones el % de {channel} en «{card}», manda el tuyo; si no, su comisión.",
    otaVat: "IVA de la comisión de {channel} ({pct}\u00a0%)",
    changeIn: "Cambiar en «{card}»",
    changeWhere: "Se cambia en «{card}».",
    notOwner: "Lo que no es del propietario",
    taxes: "Tasas e impuestos",
    taxesNote: "No son ingresos del propietario.",
    cleaning: "Limpieza que te quedas",
    cleaningNoteCharged: "Lo que paga el huésped por ella.",
    cleaningNoteFixed: "Tu importe fijo por estancia.",
    fees: "Tus honorarios de gestión",
    commission: "Comisión: {pct} % de {base}",
    commissionBase: "Base: {concepts}.",
    commissionBaseNet: "Base: {concepts}, sin su parte de la comisión de {channel}.",
    commissionBaseNetClean: "Base: lo que le queda al propietario tras {channel}, su IVA y la limpieza.",
    vat: "IVA de tu comisión ({pct} %)",
    invoice: "Total de tu factura de honorarios",
    net: "Neto para el propietario",
    netNote: "Lo que es suyo en esta reserva.",
    netNegative: "Lo que se descuenta supera lo que deja la reserva.",
    splitTitle: "Cómo se reparten los {total}",
    legendTaxes: "Tasas",
    legendCleaning: "Limpieza (tuya)",
    legendFees: "Tus honorarios",
    legendOwner: "Propietario",
    legendDeficit: "Lo que falta",
    transferTitle: "Le transfieres {amount}",
    transferTitleTo: "Le transfieres {amount} a {owner}",
    transferInvoice: "Y le emites tu factura de honorarios de {amount}.",
    owesTitle: "El propietario te debe {amount}",
    owesTitleFrom: "{owner} te debe {amount}",
    owesInvoice: "No hay nada que transferirle. Tu factura de honorarios es de {amount}.",
    owesHint: "En este ejemplo, lo que se descuenta supera lo que deja la reserva.",
    collectTitle: "El propietario te paga {amount}",
    collectTitleFrom: "{owner} te paga {amount}",
    collectBreakdown: "Es tu factura de honorarios ({fees}).",
    collectBreakdownCleaning: "Tu factura de honorarios ({fees}) más la limpieza ({cleaning}).",
    ownerLoses: "Con estas condiciones, el propietario pierde {amount} en esta reserva.",
    foot: "Importes de ejemplo. La liquidación real usa el desglose de cada reserva.",
    footNoOtaVat: "Sin el IVA de la comisión de la OTA.",
  },
  footer: {
    save: "Guardar cambios",
    saving: "Guardando…",
    unsaved: "Cambios sin guardar",
    saved: "Guardado",
    fixErrors: "Revisa los campos marcados.",
    errSave: "No se ha podido guardar. Inténtalo de nuevo.",
    peekLabel: "Le queda al propietario",
    peekAria: "Ver la liquidación de ejemplo: le queda al propietario {amount}",
  },
};
